import { convertBooleanStatusToElementStatus } from '../../../components/fixers/alt-image-fixer/utils';
const getGlobalSectionElementStatus = globalSectionElementState => {
  const updatedStatus = convertBooleanStatusToElementStatus(!!(globalSectionElementState != null && globalSectionElementState.mediaType));
  return updatedStatus;
};
export const getUpdatedMediaAlternativesFromState = (baseElements, stateMap, globalSectionStateMap) => {
  if (stateMap === undefined && globalSectionStateMap === undefined) {
    return baseElements;
  }
  const updatedMediaElements = baseElements.map(baseMedia => {
    const globalSectionElementState = globalSectionStateMap == null ? void 0 : globalSectionStateMap.get(baseMedia.id);
    const hasGlobalMediaTypeChange = (globalSectionElementState == null ? void 0 : globalSectionElementState.mediaType) !== undefined;
    const mediaState = stateMap == null ? void 0 : stateMap.get(baseMedia.id);
    const updatedMedia = {
      ...baseMedia,
      status: hasGlobalMediaTypeChange ? getGlobalSectionElementStatus(globalSectionElementState) : (mediaState == null ? void 0 : mediaState.status) ?? baseMedia.status,
      type: (globalSectionElementState == null ? void 0 : globalSectionElementState.mediaType) ?? (mediaState == null ? void 0 : mediaState.type) ?? baseMedia.type
    };
    return updatedMedia;
  });
  return updatedMediaElements;
};
//# sourceMappingURL=get-updated-media-alternatives-from-state.js.map